import { getRequest } from '@/core';
import { goodsTypes } from '@/requests';

export default async function getGoodsTypesRequest() {
	let url = goodsTypes.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}